import React from 'react';
import { Button, SwitchHorizontal01Icon } from '@metarouter-private/mr-mui';
import WithTooltip from 'app/components/WithTooltip';
import { useDrawerContext } from 'app/shared/contexts/drawer';
import { usePipelinePageContext } from 'app/pipeline-details/PipelinePageContextProvider';
import TRANSFORMATION_DRAWERS from 'app/pipeline-details/PipelineTransformationsSection/PipelineTransformationsDrawer/TRANSFORMATION_DRAWERS';
import { isNil } from 'lodash';

const DISABLED_MESSAGE = 'No transforms configured. Currently only configurable through the CLI.';

export default function PipelineTransformsButton() {
  const { pipeline } = usePipelinePageContext();
  const { launchDrawer } = useDrawerContext();
  const deployedTransform = pipeline.deployedPipeline?.transform;

  const onClick = () => {
    launchDrawer({
      drawer: TRANSFORMATION_DRAWERS.PIPELINE_TRANSFORMS,
      transform: deployedTransform,
    });
  };

  const disabled = isNil(deployedTransform);

  return (
    <WithTooltip show={disabled} title={DISABLED_MESSAGE}>
      <Button
        variant="outlined"
        size="medium"
        color="secondary"
        startIcon={<SwitchHorizontal01Icon />}
        onClick={onClick}
        disabled={disabled}
      >
        Pipeline Transforms
      </Button>
    </WithTooltip>
  );
}
